<button class="search-icon" [matMenuTriggerFor]="searchMenu"
        #menuTrigger="matMenuTrigger"
        (menuOpened)="onOpen()">
  <app-image-loading src="assets/icon_home_search.svg" alt="搜尋" i18n-alt
                     [clickable]="true"
                     [middle]="true"
                     [targetWidth]="18"
                     [targetHeight]="18"/>
</button>

<mat-menu #searchMenu="matMenu" xPosition="before" class="search-menu-panel" backdropClass="search-menu-back-drop">
  <div class="column-container menu-content" (click)="$event.stopPropagation()">
    <form class="search row-container relative"
          (submit)="onKeyword(viewModel.keyword(), true)">
      <input class="full-width" maxlength="20" #input
             (input)="inputChange($any($event.target).value, $any($event.target))"
             [value]="viewModel.keyword()"/>
      @if (!viewModel.keyword()) {
        <app-image-loading class="search-icon-margin" i18n-alt alt="搜尋" src="assets/icon_home_search.svg"
                           [clickable]="false"
                           [targetWidth]="18"
                           [targetHeight]="18"/>
      } @else {
        <button type="button" appFocusRemove (click)="viewModel.keyword.set('')">
          <app-image-loading i18n-alt alt="搜尋" src="assets/icon_search_clear.svg"
                             [clickable]="true"
                             [targetWidth]="18"
                             [targetHeight]="18"/>
        </button>
      }
    </form>
    <div class="row-container flex-start container-margin"
         [class.container-margin]="!viewModel.keyword() || !!viewModel.searchKeywords().length">
      <div class="column-container title flex-1">
        @if (!viewModel.searchKeywords().length && !viewModel.keyword()) {
          <div class="row-container">
            <app-image-loading class="icon-margin" src="assets/icon_hot.svg" alt="熱門搜尋" i18n-alt
                               [clickable]="false"
                               [targetWidth]="13"
                               [targetHeight]="20"/>
            <span i18n>熱門搜尋</span>
          </div>
          @for (hot of emptySearchModel.desktopHotKeywords(); track hot.id; let first = $first) {
            <button class="content text-ellipsis" appFocusRemove
                    [class.title-margin]="first"
                    (click)="onHotKeyword(hot.id)">{{hot.keyword}}</button>
          }
        } @else if (viewModel.searchKeywords().length) {
          <div class="row-container">
            <app-image-loading class="icon-margin" src="assets/icon_hot.svg" alt="熱門搜尋" i18n-alt
                               [clickable]="false"
                               [targetWidth]="13"
                               [targetHeight]="20"/>
            <span i18n>搜尋建議</span>
          </div>
          @for (word of viewModel.searchKeywords(); track word; let first = $first) {
            <button class="content text-ellipsis" appFocusRemove
                    [class.title-margin]="first"
                    (click)="onKeyword(word, true)">{{word}}</button>
          }
        }
      </div>
      <div class="column-container title flex-1">
        @if (!viewModel.searchKeywords().length && !viewModel.keyword()) {
          <div class="row-container space-between">
            @if (viewModel.historyKeywords().length) {
              <div class="row-container">
                <app-image-loading class="icon-margin" src="assets/icon_history.svg" alt="最近搜尋" i18n-alt
                                   [clickable]="false"
                                   [targetWidth]="13"
                                   [targetHeight]="20"/>
                <span i18n>最近搜尋</span>
              </div>
              <button class="remove-btn" appFocusRemove (click)="viewModel.removeKeywords()">
                <app-image-loading class="icon-margin" src="assets/icon_delete.svg" alt="刪除" i18n-alt
                                   [clickable]="true"
                                   [middle]="true"
                                   [targetWidth]="13"
                                   [targetHeight]="20"/>
              </button>
            }
          </div>
          @for (word of viewModel.historyKeywords(); track word; let first = $first) {
            <button class="content text-ellipsis" appFocusRemove
                    [class.title-margin]="first"
                    (click)="onKeyword(word)">{{word}}</button>
          }
        }
      </div>
    </div>
  </div>
</mat-menu>
